// ResponsiveGestionStock.jsx → src/gestion-stock/
import React from "react";
import GestionStock from "./GestionStock";
import StockMobile from "../mobile/stock/StockMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveGestionStock(props) {
  return useIsMobile() ? <StockMobile {...props} /> : <GestionStock {...props} />;
}
